interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <div className="flex items-center justify-center gap-1.5 mt-8 md:mt-10 flex-wrap">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="w-9 h-9 rounded-md border border-background-200 text-foreground-600 flex items-center justify-center hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm flex items-center justify-center transition-colors cursor-pointer ${
            p === page
              ? "bg-primary-500 text-background-50 font-medium"
              : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="w-9 h-9 rounded-md border border-background-200 text-foreground-600 flex items-center justify-center hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </div>
  );
}